<template>
  <div class="home-container">
    <div class="banner-section">
      <div class="banner-overlay"></div>
      <div class="banner-img">
        <img src="../assets/img/bgtop.jpg" alt="背景图" />
      </div>
      <div class="banner-logo">
        <img
          class="logo-img"
          src="../assets/img/toplogo.png"
          alt="公司logo"
        />
      </div>
      <div class="banner-search">
        <el-row class="search-row">
          <el-col :span="4">
            <p class="search-title">查招标</p>
          </el-col>
          <el-col :span="14">
            <el-input 
              v-model="form.xxx" 
              placeholder="请输入关键词"
              class="search-input"
            ></el-input>
          </el-col>
          <el-col :span="3">
            <el-button
              class="search-btn primary-btn"
              @click="openDialog()"
              >查一下</el-button
            >
          </el-col>
          <el-col :span="3">
            <el-button
              class="search-btn secondary-btn"
              @click="openDialog()"
              >组合查询</el-button
            >
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="dialog-section">
      <el-dialog
        :visible.sync="centerDialogVisible"
        class="login-dialog"
        width="500px"
        :show-close="false"
      >
        <div class="dialog-header">
          <h2 class="dialog-title">免费注册成为会员</h2>
        </div>

        <el-form
          :model="loginForm"
          class="login-form"
          label-position="left"
          autocomplete="on"
          :rules="loginRules"
          ref="loginForm"
        >
          <el-form-item prop="mobile">
            <div class="input-wrapper">
              <i class="el-icon-user input-icon"></i>
              <el-input
                ref="mobile"
                v-model="loginForm.mobile"
                placeholder="请输入手机号"
                name="mobile"
                type="text"
                tabindex="1"
                autocomplete="on"
                class="form-input"
              />
            </div>
          </el-form-item>
          <el-form-item prop="code">
            <div class="input-wrapper">
              <i class="el-icon-lock input-icon"></i>
              <el-input
                ref="code"
                v-model="loginForm.code"
                placeholder="请输入验证码"
                name="code"
                type="text"
                tabindex="1"
                autocomplete="on"
                maxlength="6"
                class="form-input"
              />
              <span class="verification-code">
                <span 
                  v-show="show" 
                  class="get-code-btn" 
                  @click="getCode"
                >获取验证码</span>
                <span v-show="!show" class="countdown">{{ count }}s后重新获取</span>
              </span>
            </div>
          </el-form-item>
          <el-form-item class="checkbox-item">
            <el-checkbox v-model="checked" class="agreement-checkbox">
              <el-link href="#/privacy" type="primary" target="_blank" class="agreement-link">
                《个人信息授权与隐私政策》
              </el-link>
            </el-checkbox>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false" class="cancel-btn">取 消</el-button>
          <el-button
            :loading="loading"
            type="primary"
            @click.native.prevent="handleLogin"
            class="submit-btn"
          >提交</el-button>
        </div>
      </el-dialog>
      
      <el-dialog
        :visible.sync="qrcodeVisible"
        class="qrcode-dialog"
        width="300px"
        :show-close="false"
      >
        <div class="dialog-header">
          <h3 class="dialog-subtitle">扫码下载APP</h3>
        </div>
        <div class="qrcode-content">
          <img
            class="qrcode-img"
            src="../assets/img/WechatIMG797.jpg"
            alt="二维码"
          />
        </div>
      </el-dialog>
    </div>

    <div class="main-content">
      <div class="content-wrapper">
        <div class="bidding-section">
          <div class="section-header">
            <div class="table-container">
              <el-table
                :data="tableData"
                :show-header="false"
                class="bidding-table"
                :cell-style="{ 'text-align': 'center' }"
              >
                <el-table-column type="index" width="100" class-name="index-column"></el-table-column>
                <el-table-column prop="title" class-name="title-column">
                  <template slot-scope="scope">
                    <el-link @click="openDialog()" class="bidding-link">{{
                      scope.row.title
                    }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="province_name" width="150" class-name="province-column"></el-table-column>
                <el-table-column prop="money" width="150" class-name="money-column"></el-table-column>
                <el-table-column prop="update_time" :formatter="formatDate" width="200" class-name="date-column">
                  <template slot-scope="scope">
                    <i class="el-icon-time time-icon"></i>
                    <span class="date-text">{{
                      formatDate(scope.row)
                    }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <div @click="openDialog()" class="advantages-banner"></div>
        
        <div class="advantages-section">
          <div class="section-title">
            <h2 class="title-text">选择我们的优势</h2>
            <p class="subtitle-text">获取商机进而保障业务需求</p>
          </div>
        </div>

        <div @click="openDialog()" class="advantages-image"></div>
        
        <div class="company-section">
          <div class="company-content">
            <div class="company-info">
              <h3 class="company-title">公司简介</h3>
              <p class="company-subtitle">ABOUT US</p>
              <p class="company-description">
                中经鑫主要领域是建筑行业大数据服务，全国目前有200多家分公司，主要针对建筑领域开发相关产品！
              </p>
              <p class="company-description">
                随着信息技术的不断创新，信息建设的不断深入，带动了移动应用的快速发展。为了更好的服务于建筑领域，中经鑫现推出建企悦应用，现已良好的支持iPhone和Android终端，
                目前已推出服务包括企业查询、在线加盟以及资质转让，后续将推出建筑行业服务等各类实用功能。
                在移动互联网高速发展的今天，建企悦将会在未来不断的完善和充实，为大家的工作和生活提供更为贴切的服务。
              </p>
            </div>
            <div class="company-image">
              <img src="../assets/img/jianjietopmin.jpg" alt="公司图片" class="company-img" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validPhoneNumber, validCode } from "@/utils/validate";

export default {
  components: {},
  data() {
    const validatePhoneNumber = (rule, value, callback) => {
      if (!validPhoneNumber(value)) {
        callback(new Error("手机号码格式不正确，请重新输入"));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (!validCode(value)) {
        callback(new Error("验证码格式不正确，请重新输入"));
      } else {
        callback();
      }
    };
    return {
      show: true,
      count: "",
      timer: null,
      loginForm: {
        mobile: "",
        code: "",
      },
      loginRules: {
        mobile: [
          { required: true, trigger: "blur", validator: validatePhoneNumber },
        ],
        code: [{ required: true, trigger: "blur", validator: validateCode }],
      },
      centerDialogVisible: false,
      tableData: [],
      loading: true,
      form: {},
      checked: true,
      qrcodeVisible: false,
      loginLoading: false,
    };
  },
  mounted() {
    this.$http
      .get("v1/crm/jqy_bidding?page=1")
      .then((response) => {
        this.tableData = response.data.list;
        this.loading = false;
      })
      .catch(function(error) {
        window.console.log(error);
      });
  },
  methods: {
    openDialog() { 
      this.loginForm = {
        mobile: "",
        code: "",
      }
      this.centerDialogVisible = true
    },
    formatDate(data) {
      return this.$moment.unix(data.update_time).format("YYYY-MM-DD HH:mm:ss");
    },
    getCode() {
      if (validPhoneNumber(this.loginForm.mobile)) {
        const data = {
          mobile: this.loginForm.mobile,
          type: 10,
        };
        this.$http
          .post("v1/jqy_send_msm", data)
          .then((response) => {
            window.console.log(response.msg);
            this.$message({
              message: "短信已发送，请注意查收。",
              type: "success",
            });
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          })
          .catch((error) => {
            window.console.log(error);
            this.$message({
              message: "短信发送失败，请稍后再试",
              type: "warning",
            });
          });
      } else {
        this.$message.error("手机号格式不正确，请重新输入");
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loginLoading = true;
          const data = {
            mobile: this.loginForm.mobile,
            code: this.loginForm.code,
            type: 10,
          };
          this.$http
            .post("v1/jqy_mobile_login", data)
            .then((response) => {
              window.console.log(response);
              this.loginLoading = false;
              this.$message({
                message: "验证通过",
                type: "success",
              });
              this.centerDialogVisible = false;
              this.qrcodeVisible = true;
            })
            .catch((error) => {
              window.console.log(error);
              this.$message({
                message: "验证失败，请重新输入",
                type: "warning",
              });
              this.loginLoading = false;
            });
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http
            .post("v1/crm/jqy_web_message/_create", this.form)
            .then((response) => {
              window.console.log(response);
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.centerDialogVisible = false;
            })
            .catch(function(error) {
              window.console.log(error);
            });
        } else {
          window.console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home-container {
  width: 100%;
  background-color: #f5f5f5;
}

.banner-section {
  width: 100%;
  height: 400px;
  position: relative;
  overflow: hidden;
  
  .banner-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    // background: rgba(0, 0, 0, 0.8);
    z-index: 1;
  }
  
  .banner-img {
    position: absolute;
    width: 100%;
    height: 100%;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  
  .banner-logo {
    position: absolute;
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    
    .logo-img {
      width: 400px;
      height: auto;
    }
  }
  
  .banner-search {
    position: absolute;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    max-width: 1000px;
    z-index: 2;
    
    .search-row {
      display: flex;
      align-items: center;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 8px;
      padding: 20px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      
      .search-title {
        font-size: 20px;
        font-weight: 600;
        color: #333;
        margin: 0;
        margin-left: 20%;
      }
      
      .search-input {
        width: 100%;
        
        ::v-deep .el-input__inner {
          height: 45px;
          border-radius: 4px;
        }
      }
      
      .search-btn {
        height: 45px;
        font-size: 16px;
        font-weight: 500;
        border-radius: 4px;
        margin-left: 10px;
        cursor: pointer;
        transition: all 0.3s ease;
        
        &.primary-btn {
          // background-color: #e13834;
          // border-color: #e13834;
          
          // &:hover {
          //   background-color: #c12824;
          //   border-color: #c12824;
          // }
        }
        
        &.secondary-btn {
          // background-color: #14679f;
          // border-color: #14679f;
          
          &:hover {
            // background-color: #0f5280;
            // border-color: #0f5280;
          }
        }
      }
    }
  }
}

.dialog-section {
  .login-dialog {
    .dialog-header {
      text-align: center;
      padding: 20px 0;
      background: linear-gradient(to right, #14679f, #1a7bc5);
      
      .dialog-title {
        color: white;
        margin: 0;
        font-size: 24px;
        font-weight: 500;
      }
    }
    
    .login-form {
      padding: 30px;
      
      .input-wrapper {
        position: relative;
        
        .input-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: #909399;
          z-index: 1;
        }
        
        .form-input {
          ::v-deep .el-input__inner {
            padding-left: 35px;
            height: 45px;
            border-radius: 4px;
          }
        }
        
        .verification-code {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
          
          .get-code-btn {
            color: #14679f;
            cursor: pointer;
            font-weight: 500;
            
            &:hover {
              color: #0f5280;
            }
          }
          
          .countdown {
            color: #909399;
          }
        }
      }
      
      .checkbox-item {
        ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
          color: #606266;
        }
        
        .agreement-link {
          font-size: 14px;
        }
      }
    }
    
    .dialog-footer {
      padding: 20px 30px 30px;
      text-align: center;
      
      .cancel-btn {
        padding: 12px 30px;
        font-size: 16px;
        border-radius: 4px;
      }
      
      .submit-btn {
        padding: 12px 30px;
        font-size: 16px;
        border-radius: 4px;
        background-color: #14679f;
        border-color: #14679f;
        
        &:hover {
          background-color: #0f5280;
          border-color: #0f5280;
        }
      }
    }
  }
  
  .qrcode-dialog {
    .dialog-header {
      text-align: center;
      padding: 15px 0;
      
      .dialog-subtitle {
        margin: 0;
        color: #333;
        font-size: 20px;
        font-weight: 500;
      }
    }
    
    .qrcode-content {
      text-align: center;
      padding: 20px;
      
      .qrcode-img {
        width: 200px;
        height: 200px;
      }
    }
  }
}

.main-content {
  padding: 40px 0;
  
  .content-wrapper {
    width: 1200px;
    margin: 0 auto;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    padding: 30px;
    
    .bidding-section {
      margin-bottom: 40px;
      
      .section-header {
        .table-container {
          .bidding-table {
            ::v-deep .index-column {
              color: #909399;
              font-weight: 500;
            }
            
            ::v-deep .title-column {
              .bidding-link {
                color: #14679f;
                font-weight: 500;
                
                &:hover {
                  color: #0f5280;
                }
              }
            }
            
            ::v-deep .province-column,
            ::v-deep .money-column {
              color: #606266;
            }
            
            ::v-deep .date-column {
              .time-icon {
                margin-right: 5px;
                color: #909399;
              }
              
              .date-text {
                color: #909399;
              }
            }
          }
        }
      }
    }
    
    .advantages-banner {
      background-image: url(../assets/img/WechatIMG1411.jpeg);
      background-position: center;
      background-size: cover;
      width: 100%;
      height: 100px;
      border-radius: 8px;
      margin: 20px 0;
      cursor: pointer;
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
    }
    
    .advantages-section {
      text-align: center;
      margin: 40px 0;
      
      .section-title {
        .title-text {
          font-size: 32px;
          color: #14679f;
          margin-bottom: 15px;
          font-weight: 600;
        }
        
        .subtitle-text {
          font-size: 18px;
          color: #666;
          margin: 0;
        }
      }
    }
    
    .advantages-image {
      background-image: url(../assets/img/WechatIMG1404.jpeg);
      background-position: center;
      background-size: cover;
      width: 100%;
      height: 300px;
      border-radius: 8px;
      margin: 0 auto 40px;
      cursor: pointer;
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
    }
    
    .company-section {
      .company-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 60px 0;
        
        .company-info {
          flex: 1;
          padding-right: 40px;
          
          .company-title {
            font-size: 28px;
            color: #e13834;
            margin-bottom: 10px;
            font-weight: 600;
          }
          
          .company-subtitle {
            font-size: 18px;
            color: #e13834;
            margin: 20px 0;
            font-weight: 500;
          }
          
          .company-description {
            color: #14679f;
            font-size: 16px;
            line-height: 1.8;
            text-align: justify;
            margin-bottom: 20px;
          }
        }
        
        .company-image {
          flex: 1;
          text-align: center;
          
          .company-img {
            width: 100%;
            max-width: 400px;
            height: auto;
            border: 2px solid #1d42b9;
            border-radius: 10px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .main-content .content-wrapper {
    width: 95%;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .banner-section {
    height: 300px;
    
    .banner-logo .logo-img {
      width: 300px;
    }
    
    .banner-search {
      width: 90%;
      bottom: 30px;
      
      .search-row {
        flex-direction: column;
        background: rgba(255, 255, 255, 0.95);
        
        .el-col {
          width: 100%;
          margin-bottom: 15px;
          
          &:last-child {
            margin-bottom: 0;
          }
        }
        
        .search-title {
          text-align: center;
        }
        
        .search-input {
          ::v-deep .el-input__inner {
            height: 40px;
          }
        }
        
        .search-btn {
          width: 100%;
          height: 40px;
          margin-left: 0;
        }
      }
    }
  }
  
  .main-content .content-wrapper {
    padding: 20px 15px;
    
    .company-section .company-content {
      flex-direction: column;
      
      .company-info {
        padding-right: 0;
        margin-bottom: 30px;
      }
      
      .company-image {
        .company-img {
          max-width: 100%;
        }
      }
    }
  }
  
  .advantages-image {
    height: 200px;
  }
}
</style>
